import { round } from '@aninix-inc/model'

export const defaultFigmaLikeFormat = (value: number) =>
  round(value, { fixed: 2 }).toString()
